import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link, Outlet, redirect } from "@tanstack/react-router";
import { pendingRequestsQuery } from "@/lib/api/queries";

export const Route = createFileRoute("/_app/admin")({
  beforeLoad: ({ context }) => {
    if (context.session.user.role !== "admin") throw redirect({ to: "/" });
  },
  component: AdminLayout,
});

const SECTIONS = [
  { to: "/admin", label: "Обзор", exact: true },
  { to: "/admin/users", label: "Пользователи" },
  { to: "/admin/configs", label: "Конфиги" },
  { to: "/admin/stats", label: "Статистика" },
  { to: "/admin/requests", label: "Запросы" },
  { to: "/admin/invites", label: "Инвайты" },
  { to: "/admin/announcements", label: "Объявления" },
  { to: "/admin/audit", label: "Журнал" },
] as const;

function AdminLayout() {
  const pending = useQuery(pendingRequestsQuery).data?.count ?? 0;
  return (
    <div className="mx-auto max-w-5xl px-4 pt-6 pb-16">
      <nav
        aria-label="Разделы админки"
        className="-mx-4 flex gap-1 overflow-x-auto px-4 pb-2 [scrollbar-width:none]"
      >
        {SECTIONS.map((section) => (
          <Link
            key={section.to}
            to={section.to}
            activeOptions={{ exact: "exact" in section }}
            className="h-9 shrink-0 rounded-lg px-3 text-sm leading-9 text-muted hover:text-text"
            activeProps={{ className: "bg-surface-2 !text-text" }}
          >
            {section.label}
            {section.to === "/admin/requests" && pending > 0 && (
              <span className="ml-1.5 inline-block min-w-5 rounded-full bg-amber px-1.5 text-center text-xs leading-5 text-amber-ink">
                <span className="sr-only">ожидают: </span>
                {pending}
              </span>
            )}
          </Link>
        ))}
      </nav>
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
